//TODO: Este documento se crea para las apis que se ocuapn de paquetes V2 del mayorista

import axios from "axios"
import { APIURL } from "./../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlFligth = "Fligth"

//* Metodo para traer todos los vuleos paginado
//* GET /api/Fligth/V2/Supplier/{IdProveedor}/{Pagina}/{Registros}
export const getVuelosProveedorAll = async ({ IdProveedor, Pagina, Registros}) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/${IdProveedor}/${Pagina}/${Registros}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return {}
        // return getError(Error);
    })
}

//* Metodo para buscar vuelos por id proveedor
//* GET /api/Fligth/V2/Supplier/{IdProveedor}
export const getVuelosProveedorID = async ({ IdProveedor }) => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/${IdProveedor}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}
//* Metodo para agregar vuelo proveedor
//* POST /api/Fligth/V2/Supplier 
export const newVueloProveedor = async ({
    IdProveedor,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida,
        IdOrigen,
        IdDestino,
        EsRedondo,
        VueloRedondo,
}) => {
    return await axios.post(`${APIURL}/${urlFligth}/V2/Supplier`, {
        IdProveedor,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida,
        IdOrigen,
        IdDestino,
        EsRedondo,
        VueloRedondo,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar vuelos proveedor
//* PUT /api/Fligth/V2/Supplier/{IdVueloProveedor}
export const putVueloProveedor = async ({ 
    IdVueloProveedor,
    IdProveedor,
    IdMoneda,
    ClaveVuelo,
    PrecioNeto,
    Disponibilidad,
    FechaSalida,
    IdOrigen,
    IdDestino,
    EsRedondo,
    VueloRedondo
 }) => {
    return await axios.put(`${APIURL}/${urlFligth}/V2/Supplier/${IdVueloProveedor}`, {
        IdProveedor,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida,
        IdOrigen,
        IdDestino,
        EsRedondo,
        VueloRedondo
    },{
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para obtener lista de vuelos 
//* GET /api/Fligth/V2/Supplier/List
export const getVuelosProveedoLista = async () => {
    return await axios.get(`${APIURL}/${urlFligth}/V2/Supplier/List`,{
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}